<template>
    <div>
        <!-- <div class="tabsFather">
            <div v-for="(item,index) in tabsData" :class="[tabsIndex == item.type ? 'tabsActive' : '','tabsClass']"  @click="tabsClick(item)">{{ item.title }}</div>
        </div> -->
        <div class="line999"></div>
        <template v-if="tabsIndex == '10'">
            <div class="commonFather">
                <div class="commonList" v-for="(item,index) in tabsData" :key="index"  @click="tabsClick(index)">
                    <div class="commonListLeft">{{ item.title }}</div>
                    <div class="commonListRight">{{ item.date }}</div>
                </div>
            </div>
        
            <div class="line999"></div>
            <div class="mob-line"></div>
            <!-- <van-pagination v-model="currentPage" :total-items="1" :items-per-page="5" /> -->
            
        </template>
       
        <template>
            <!-- <div class="tabs1Title">大事记</div> -->
            <div class="tabs1">
                <div class="Articlebox">
                    <h1>{{details.title}}</h1>
                    <div class="a-text-c">
                        <div v-html="details.text"> 
                            
                        </div> 
                    </div>
                </div>
                
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "mobIntroduce",
        data(){
            return{
                tabsData:[
                    {title:"公司新闻",index:'3-1',date:"2016-07-14",type:'2'},
                    {title:"媒体新闻",index:'3-2',date:"2017-01-01",type:'1'},
                ],
                currentPage:"1",
                tabsIndex:"3",
                details:{
                    title:"",text:""
                },
               
            }
        },
        methods:{
            tabsClick(e){
                console.log(e)
                this.tabsIndex = e.type
                console.log( this.tabsIndex)
                this.$router.push({path: "mobNews",query:{type:e.type}}); 

            },
            goDetails(e){
                console.log(e)
                this.tabsIndex = e.type
                this.$router.push({path: "mobNewsDetails",query:{data:e}});  
            },
        },
        created(e){
            
        }
    }
</script>

<style scoped>
.a-text-c{
    font-size: 0.38rem;
    color: #000;
    padding: 5px 0.4rem;
}
.Articlebox h1 {
    display: block;
    padding: 0px 0 5px 5px;
    text-align: center;
    font-size: 0.43rem;
    font-weight: 600;
}
.pageClass{
    width: 100%;
    text-align: center;
}
.commonListRight{
    color: #999;
    font-size: 0.34rem;
}
.commonListLeft{
    font-size: 0.38rem;
    color: #000;
    width: 80%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.commonList{
    padding: 0.2rem;
    display: flex;
    justify-content: space-between;
}
.commonFather{
    background-color: #fff;
}
.detailClass{
    margin-top: 0px; 
    margin-bottom: 0px; 
    padding: 15px 0px 15px 65px; 
    border-width: 0px 0px 1px; 
    border-top-style: initial; 
    border-right-style: initial; 
    border-bottom-style: solid; 
    border-left-style: initial; 
    border-top-color: initial; 
    border-right-color: initial; 
    border-bottom-color: rgb(221, 221, 221); 
    border-left-color: initial; 
    border-image: initial; 
    font-size: 15px; 
    line-height: 28px;
}
.monClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    width: 52px; 
    height: 28px; 
    display: block; 
    background-color: rgb(185, 185, 185); 
    text-align: center; 
    color: rgb(255, 255, 255); 
    font-size: 18px;
}
.ulClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    /* width: 80%;  */
    /* float: right;  */
    position: relative;
}
.h2Class{
    /* margin: 0px 0px 0px; */
    margin-right: 50px;
    padding: 0px; 
    font-size: 18px !important; 
    width: 80px; 
    /* float: left;  */
    color: rgb(137, 137, 137); 
    line-height: 28px;
}
.tabs1Title{
    text-align: center;
    font-size: 0.45rem;
    font-weight: 600;
    padding-top: 0.4rem;
}
.tabs1{
    font-size: 0.35rem;
    padding: 0.2rem 0.01rem;
    /* line-height: 2rem; */
}
.tabsActive{
    color: #18D1BB !important;
}
.pageClass{
    width: 100%;
    text-align: center;
}
.mob-line{
    width: 100%;
    height: 0.08rem;
    background-color: #18D1BB;
    /* margin: 0.2rem 0; */
}
.commonListRight{
    color: #999;
    font-size: 0.34rem;
}
.commonListLeft{
    font-size: 0.38rem;
    color: #000;
}
.commonList{
    padding: 0.2rem;
    display: flex;
    justify-content: space-between;
}
.line999{
    width: 100%;
    height: 6px;
    background-color: #eee;
}
.commonFather{
    background-color: #fff;
}
.tabsClass{
   
    color: #333;
    font-size: 0.38rem;
    margin-right: 15px;
}
.tabsFather{
    display: flex;
    align-items: center;
    padding-left: 15px;
    height: 44px;
    line-height: 44px;
}
</style>